import {
    FETCH_RESPIRATION_REPORTS_DATA,
    FETCH_RESPIRATION_REPORTS_DATA_FETCHING,
    FETCH_RESPIRATION_REPORTS_DATA_SUCCESS,
    FETCH_RESPIRATION_REPORTS_DATA_FAIL
} from '../../actions/ActionTypes.js';

const INITIAL_STATE = {
    respirationReportsData: [],
    isFetching: false,
    fetchFailed: false
};

const fetchRespirationReportsDataFetching = (state) => {
    return {
        ...state,
        isFetching: true,
        fetchFailed: false
    };
};

const fetchRespirationReportsDataSuccess = (state, action) => {
    return {
        ...state,
        respirationReportsData: action.respirationReportsData,
        isFetching: false,
        fetchFailed: false
    };
};

const fetchRespirationReportsDataFail = (state, action) => {
    return {
        ...state,
        isFetching: false,
        fetchFailed: true
    };
};

const handlers = {
    [FETCH_RESPIRATION_REPORTS_DATA_FETCHING]: fetchRespirationReportsDataFetching,
    [FETCH_RESPIRATION_REPORTS_DATA_SUCCESS]: fetchRespirationReportsDataSuccess,
    [FETCH_RESPIRATION_REPORTS_DATA_FAIL]: fetchRespirationReportsDataFail
};

export default function respirationReportsData(state = INITIAL_STATE, action = {}) {
    const handler = handlers[action.type];

    if (!handler) return state;
    return handler(state, action);
}

// Actions
export function fetchRespirationReportsData(displayName, startDate, endDate, nonSleepBufferMinutes, evictCache) {
    return {
        type: FETCH_RESPIRATION_REPORTS_DATA,
        displayName,
        startDate,
        endDate,
        nonSleepBufferMinutes
    };
}

export const getRespirationReportsData = (state) => {
    return state.respirationReportsData.respirationReportsData
        ? state.respirationReportsData.respirationReportsData
        : null;
};

export const isRespirationReportsDataFetching = (state) => {
    return state.respirationReportsData.isFetching;
};

export const isRespirationReportsDataFetchFail = (state) => {
    return state.respirationReportsData.fetchFailed;
};
